import React from 'react';
import { backgroundOverlay, backgroundStyle, backgroundValue, clamp, cleanHtml, externalLink, gradientStyle } from '../utils/presentation';
import { imageUrl } from '../utils/setModel';

const socialUrl = ({ platform, handle }) => {
  if (!handle) return '';
  if (/^https?:\/\//i.test(handle)) return handle;
  const clean = handle.replace(/^@/, '');
  const bases = { twitter: 'https://x.com/', facebook: 'https://facebook.com/', instagram: 'https://instagram.com/', linkedin: 'https://linkedin.com/in/', youtube: 'https://youtube.com/@', discord: 'https://discord.gg/', twitch: 'https://twitch.tv/' };
  return platform === 'website' ? externalLink(handle) : `${bases[platform] || ''}${clean}`;
};

export default function IntroductionModule({ module }) {
  const data = module.data || {};
  const logo = imageUrl(data.logo);
  const validSocials = (data.socialLinks || []).filter((item) => item?.platform && item?.handle);
  const style = {
    ...backgroundStyle(backgroundValue(data), { size: data.backgroundSize || 'cover', position: data.backgroundPosition || 'center', tileSize: data.backgroundTileSize }),
    backgroundColor: data.backgroundColor || '#12151c',
    '--hero-min-height': `${clamp(data.minHeight, 50, 100, 95)}vh`,
    '--hero-overlay': backgroundOverlay(data, 35),
  };
  return (
    <section className={`set-presentation-section set-hero set-align-${data.contentAlign || 'center'} ${validSocials.length ? 'set-has-social-links' : ''}`} style={style}>
      <div className="set-presentation-shade" />
      <div className="set-presentation-gradient" style={gradientStyle(data, { direction: 'to bottom', strength: 82 })} />
      <div className="container set-hero-content">
        {data.eyebrow && <span className="set-presentation-eyebrow">{data.eyebrow}</span>}
        {logo && <img className="set-hero-logo" src={logo} alt={data.title || 'Set logo'} />}
        {data.title && <h1 dangerouslySetInnerHTML={{ __html: cleanHtml(data.title) }} />}
        {data.content && <div className="set-presentation-copy" dangerouslySetInnerHTML={{ __html: cleanHtml(data.content) }} />}
        {validSocials.length > 0 && <nav className="set-hero-socials" aria-label="Creator links">{validSocials.map((social) => <a key={social.id || social.platform} href={socialUrl(social)} target="_blank" rel="noreferrer">{social.platform}</a>)}</nav>}
      </div>
    </section>
  );
}
